/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RejectAgentPairingOperatorSpec { 
    /**
     * Agent Id.
     */
    agent_id?: string;
    /**
     * User code generated to pair agent.
     */
    user_code?: string;
}

